<template>
  <span class="label">{{ text }}</span>
</template>

<script>
export default {
  name: "TextBadge",
  props: {
    text: { type: String, default: "" }
  }
};

</script>

<style lang="scss" scoped>


.label {
  border-radius: 4px;
  background-color: rgba(154, 194, 225, 0.500884);
  padding: 1px 5px 3px 5px;
  color: rgba(40, 62, 89, 1);
  font-family: "ArialMT", serif;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  letter-spacing: 0;
  text-align: left;
  line-height: 18px;
  margin: 0 0 0 8px;
}
</style>